import { render, staticRenderFns } from "./ControlRisk.vue?vue&type=template&id=df5ee0ac&"
import script from "./ControlRisk.vue?vue&type=script&lang=js&"
export * from "./ControlRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports